import React, { useState, useEffect } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { fetchUserForms } from "../UserFormsList/api";
const DateComponent = ({
  onSave,
  closeSidebar,
  fieldName,
  required,
  linked,
  database,
  field,
}) => {
  const [isRequired, setIsRequired] = useState(required || false);
  const [isLinked, setIsLinked] = useState(linked || false);
  const [selectedDatabase, setSelectedDatabase] = useState(database || null);
  const [showFieldsDropdown, setShowFieldsDropdown] = useState(false);
  const [selectedField, setSelectedField] = useState(field || null);
  const [formsList, setFormsList] = useState([]);

  useEffect(() => {
    const getForms = async () => {
      try {
        const forms = await fetchUserForms();
        setFormsList(forms);
      } catch (error) {
        console.error("Error fetching forms:", error);
      }
    };

    getForms();
  }, []);

  useEffect(() => {
    if (isLinked) {
      setShowFieldsDropdown(true);
    } else {
      setShowFieldsDropdown(false);
      setSelectedDatabase(null);
      setSelectedField(null);
    }
  }, [isLinked]);

  useEffect(() => {
    if (selectedDatabase) {
      setShowFieldsDropdown(true);
    } else {
      setShowFieldsDropdown(false);
    }
  }, [selectedDatabase]);

  const handleSave = () => {
    const fieldData = {
      name: fieldName,
      type: "date",
      required: isRequired,
      linked: isLinked,
      database: selectedDatabase,
      field: selectedField,
      databaseId: selectedDatabase ? selectedDatabase.id : undefined,
    };
    const saveSuccessful = onSave(fieldData);
    if (saveSuccessful) {
      closeSidebar();
    }
  };

  return (
    <div className="p-field">
      <Divider />
      <div className="p-field-checkbox mb-3">
        <label className="font-medium" htmlFor="required">
          Required :{" "}
        </label>
        <InputSwitch
          inputId="required"
          checked={isRequired}
          onChange={(e) => setIsRequired(e.value)}
          style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
        />
      </div>
      <Divider />
      <div className="p-field mb-3">
        <label htmlFor="linked" className="block text-900 font-medium mb-2">
          Link it to an existing DB :
          <InputSwitch
            checked={isLinked}
            onChange={(e) => setIsLinked(e.value)}
            style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
          />
        </label>
      </div>
      {isLinked && (
        <div className="p-field mb-3">
          <Divider />
          <label
            htmlFor="databases"
            className="block text-900 font-medium mb-2"
          >
            Forms
          </label>
          <Dropdown
            filter
            id="databases"
            value={selectedDatabase}
            options={formsList.map((form) => ({
              label: form.title,
              value: form.id,
            }))}
            onChange={(e) => setSelectedDatabase(e.value)}
            placeholder="Select a Form"
            className="w-full mb-3"
          />
          {showFieldsDropdown && selectedDatabase && (
            <div className="p-field">
              <Divider />
              <label
                htmlFor="fields"
                className="block text-900 font-medium mb-2"
              >
                Select Field
              </label>
              <Dropdown
                filter
                id="fields"
                value={selectedField}
                options={
                  formsList.find((form) => form.id === selectedDatabase)
                    ?.properties
                    ? Object.keys(
                        formsList.find((form) => form.id === selectedDatabase)
                          .properties
                      ).map((key) => ({
                        label: key,
                        value: key,
                      }))
                    : []
                }
                onChange={(e) => setSelectedField(e.value)}
                placeholder="Select a Field"
                className="w-full mb-3"
              />
            </div>
          )}
        </div>
      )}
      <Button
        label="Save"
        icon="pi pi-check"
        style={{
          color: "#fff",
          backgroundColor: "#0D2E4D",
          border: "none",
          fontFamily: "poppins",
        }}
        onClick={handleSave}
      />
    </div>
  );
};

export default DateComponent;
